<div class="alert-modal" [ngClass]="isImage ? 'p-none m-none p-top' : ''">
    <ion-button class="close-btn" fill="clear" (click)="onClose()">
        <ion-icon name="close-circle-outline" color="primary"></ion-icon>
    </ion-button>

    @if (type !== 'none') {
    <ion-icon [name]="type === 'error' ? 'close-circle-outline' : 'checkmark-circle-outline'" [color]="headerColor"
        class="alert-icon mb-large"></ion-icon>
    }

    <h3 class="text-primary mb-small title-alert">{{ title }}</h3>
    @if (description && !descriptionHtml) {
    <p class="mb-large">{{ description }}</p>
    }

    @if (!description && descriptionHtml) {
    <div class="mb-large" [innerHTML]="descriptionHtml"></div>
    }

    @if (confirmText || cancelText) {
    <div class="actions">
        @if (cancelText) {
        <ion-button fill="clear" color="primary" fill="outline" (click)="onCancel()">
            {{ cancelText }}
        </ion-button>
        }
        @if (confirmText) {
        <ion-button color="primary" (click)="onConfirm()">
            {{ confirmText }}
        </ion-button>
        }
    </div>
    }
</div>